import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";

export default function RotatingHint({ hints, onPick, intervalMs = 3800 }) {
  const [i, setI] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setI((n) => (n + 1) % hints.length), intervalMs);
    return () => clearInterval(id);
  }, [hints.length, intervalMs]);

  return (
    <div className="h-6 flex items-center justify-center">
      <AnimatePresence mode="wait">
        <motion.button
          key={i}
          type="button"
          onClick={() => onPick(hints[i])}
          initial={{ opacity: 0, y: 6 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -6 }}
          transition={{ duration: 0.35 }}
          className="text-[12px] tracking-wide text-neutral-400 hover:text-neutral-900 transition-colors"
          data-testid="rotating-hint"
        >
          <span className="mr-1.5 text-[#C5A059]">✧</span>
          {hints[i]}
        </motion.button>
      </AnimatePresence>
    </div>
  );
}
